import { createReducer, on } from '@ngrx/store'
import { BarterState } from '../../../../api/backend'
import { BarterListActions } from './action-types'
import { PerfectScrollbarActions } from '../../../../shared/ui/perfect-scrollbar/state/actions-type'
import { StoreKeysEnum } from '../../../../store/store-keys'
import cloneDeep from 'lodash/cloneDeep'

const INIT_STATE: IBarterListState = {
    filterCriteria: {
        barterNumberOfficial: null,
        counterpartySearchText: '',
        counterpartyId: 0,
        offset: 0,
        limit: 20,
        sortDir: 'asc',
        sortedBy: 'expirationDate',
        state: [BarterState.VALID, BarterState.PROPOSAL],
        concernedSubjectId: null,
        concernedSubjectSearchText: null,
    },
    itemCollection: null,
    filter: null,
}

export const barterListReducer = createReducer(
    INIT_STATE,
    // =======================
    //  NECESSARY REDUCER TO WORK WITH PERFECT SCROLLBAR
    //  CANT BE MOVED TO EFFECT SINCE IT NEEDS TO RUN AT FIRST BEFORE OTHER EFFECTS
    // =======================
    on(PerfectScrollbarActions.updateOriginFilterCriteria, (state, props): IBarterListState =>
        props.key === StoreKeysEnum.BarterListFeature ?
            { ...state, filterCriteria: { ...state.filterCriteria, ...props.fragment } } : state
    ),
    // =======================
    on(BarterListActions.setItemCollection, (state, { itemCollection }): IBarterListState =>
        ({ ...state, itemCollection }),
    ),
    on(BarterListActions.setFilterCriteria, (state, { filterCriteria }): IBarterListState =>
        ({ ...state, filterCriteria }),
    ),
    on(BarterListActions.setFilter, (state, { filter }): IBarterListState =>
        ({ ...state, filter }),
    ),
    on(BarterListActions.updateFilterCriteria, (state, { criteriaFragment }): IBarterListState => {
        let filterCriteriaCopy = { ...state.filterCriteria }
        let fragment = { ...criteriaFragment }

        // barter list criteria use its own naming for ca-subject-search component properties
        if (fragment.subjectSearchText !== undefined) {
            filterCriteriaCopy.counterpartySearchText = fragment.subjectSearchText

            delete fragment.subjectSearchText
        }

        if (fragment.subjectId !== undefined) {
            filterCriteriaCopy.counterpartyId = fragment.subjectId

            delete fragment.subjectId
        }

        return { ...state, filterCriteria: { ...filterCriteriaCopy, ...fragment }}
    }),
    on(BarterListActions.updateFilterCriteriaAndFilter, (state, { criteriaFragment }): IBarterListState => {
        let filterCriteriaCopy = { ...state.filterCriteria }
        let fragment = { ...criteriaFragment }

        // barter list criteria use its own naming for ca-subject-search component properties
        if (fragment.subjectSearchText !== undefined) {
            filterCriteriaCopy.counterpartySearchText = fragment.subjectSearchText

            delete fragment.subjectSearchText
        }

        if (fragment.subjectId !== undefined) {
            filterCriteriaCopy.counterpartyId = fragment.subjectId

            delete fragment.subjectId
        }

        return { ...state, filterCriteria: { ...filterCriteriaCopy, ...fragment }}
    }),
    on(BarterListActions.resetFilterCriteria, (state): IBarterListState => {
        const newState = cloneDeep(state)
        newState.filterCriteria = INIT_STATE.filterCriteria
        return newState
    }),
    on(BarterListActions.resetItemCollection, (state): IBarterListState => {
        const newState = cloneDeep(state)
        newState.itemCollection = INIT_STATE.itemCollection
        return newState
    }),
    on(BarterListActions.resetFilter, (state): IBarterListState => {
        const newState = cloneDeep(state)
        newState.filter = INIT_STATE.filter
        return newState
    }),
)

export interface IBarterListState {
    filterCriteria: IBarterListFilterCriteria;
    itemCollection: any;
    filter: any;
}

export interface IBarterListFilterCriteria {
    barterNumberOfficial: string;
    counterpartySearchText: string;
    counterpartyId: number;
    offset: number;
    limit: number;
    sortDir: string;
    sortedBy: string;
    state: BarterState[];
    concernedSubjectId: number;
    concernedSubjectSearchText: string;
    departmentCountFilterType?: departmentCountFilterEnum;
}

export enum departmentCountFilterEnum {
    ALL = 'ALL',
    NONE = 'NONE',
    ONE = 'ONE',
    MORE = 'MORE'
}
